module.exports = __webpack_public_path__ + "img/logo.c1fe6721.png";